export class Constants {

    //API
    public static analysisRequestsEndpoint = '/api/analysisrequests';

    //Pages
    public static loginPage = '/login';
    public static passRecoveryPage = '/pass-recovery';
    public static passConfirmPage = '/restore-password';
    public static analysisRequestPage = '/analysis-request';
    public static customersPanelPage = '/customers-panel';
    public static usersPanelPage = '/users-panel';
    public static qrAuthPage = '/qr-auth';

    //Query parameters
    public static OrganizationIdParam = 'organizationid';

    //Regex
    public static maxPassLength = 100;
    /* eslint-disable no-control-regex */
    public static emailRegex = /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/; // RFC 2822
    public static passRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/;
    public static mediumPassLength = 12;
    public static strongPassLength = 15;

    //Params
    public static idParam = 'id';
    public static emailParam = 'email';
    public static confirmTokenParam = 'confirm-token';
    public static currentUser = 'currentUser';

    //Time
    public static searchTimeOut = 500; // milliseconds
    public static updateTableAfterRetriggerTimeOut = 2000; // milliseconds
    public static idleLogOutTime = 1800; // seconds
    public static logOutModalTime = 10; // seconds
    public static refreshRequestsInterval = 30; //seconds

    //

    public static lang = 'lang';
    public static defaultLang = 'en-GB';
    public static isSelectedAdminMode = 'isSelectedAdminMode';
    public static currentPage = 'currentPage';
    public static logoutState = 'logoutState';

}
